import { SkuParser } from '@jouzen/ecom-commons';

// SkuParser exposes the channel prefix (e.g. NT-) but can't strip it
export const stripSkuPrefix = (sku: string) => {
  const { prefix } = new SkuParser(sku);
  return prefix ? sku.slice(prefix.length + 1) : sku;
};
